// extracted by mini-css-extract-plugin
export var text = "_4u-0";